export default __webpack_public_path__ + "static/media/nature.dc1d0696.jpg";